export default __webpack_public_path__ + "static/media/nfts-min.c5ef5e8b.gif";